export default (name: string) => `${name}-${new Date().toISOString().split('T')[0]}.pdf`;
